import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=499c1c92&scoped=true&"
import script from "./PromotionCard.vue?vue&type=script&lang=ts&"
export * from "./PromotionCard.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionCard.vue?vue&type=style&index=0&id=499c1c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c1c92",
  null
  
)

export default component.exports